<template>
  <div class="card pad10">
    <el-table :data="tableData" stripe style="width: 100%" @row-click="detail">
      <el-table-column :prop="item.prop" :label="item.label" :width="item.width" v-for="item in column">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click.stop="conso(scope)" type="text">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    column: {
      //表头
      type: Array,
      required: true,
    },
    tableData: {
      //表格数据
      type: Array,
      required: true,
    },
    total: {
      //总页数
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,

    };
  },
  computed: {},
  watch: {},
  methods: {
    detail(row, column, event) {
      this.$router.push({ name: 'serviceRecordDetail', params: { id: row.id } })
      // console.log(row, column, event)
    },
    conso(val) {
      // console.log(val)
    },
    consos(val) {
      // console.log(val)
    },
    handleSizeChange(val) {
      this.pageSize = val
      let params = {
        currentPage: 1,
        pageSize: val
      }
      this.$emit("get-list", params)
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val
      let params = {
        currentPage: val,
        pageSize: this.pageSize
      }
      this.$emit("get-list", params)
      // console.log(`当前页: ${val}`);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.status {
  display: flex;
  align-items: center;
  i {
    font-size: 22px;
    margin-right: 6px;
  }
}
</style>
